import { LifeAreaGoalCounts } from '@griply/utils';
import { ID } from 'shared/types/id';
import { LifeArea } from 'shared/types/life-area';

import { LifeAreaRowData } from '../types';

export const mapLifeAreaToRowData = (
  lifeArea: LifeArea,
  countsByLifeArea: Record<ID, LifeAreaGoalCounts>,
): LifeAreaRowData => {
  const counts = countsByLifeArea[lifeArea.id];

  return {
    id: lifeArea.id,
    name: lifeArea.name,
    image: lifeArea.visionPreview?.image ?? null,
    visionDescription: lifeArea.visionPreview?.description || null,
    color: lifeArea.color ?? null,
    iconName: lifeArea.iconName,
    goals: counts?.goals ?? 0,
    projects: counts?.projects ?? 0,
    lifeArea,
  };
};
